// extracted by mini-css-extract-plugin
export var cardHeader = "_g7-0";
export var reorderHandle = "_g7-3";
export var titleArea = "_g7-1";
export var titleAreaWithHandle = "_g7-2";